import * as React from "react";
import { FolderOpen } from "lucide-react";
import { EmptyState } from "@/components/ui/empty-state";

interface ChatBlockedStateProps {
  onOpenSelector: () => void;
}

export const ChatBlockedState: React.FC<ChatBlockedStateProps> = ({ onOpenSelector }) => {
  return (
    <div className="flex items-center justify-center h-full bg-slate-50/50">
      <EmptyState
        icon={FolderOpen}
        title="Select a project"
        description="To start using the Agent, you need to select an existing project or create a new one."
        actionLabel="Select Project"
        ActionIcon={FolderOpen}
        onAction={onOpenSelector}
        variant="primary"
      />
    </div>
  );
};

export default ChatBlockedState;
